export const options = {
  state: [
    { label: 'Alabama', value: 'alabama' },
    { label: 'Alaska', value: 'alaska' },
    { label: 'Arizona', value: 'arizona' },
    { label: 'Arkansas', value: 'arkansas' },
    { label: 'California', value: 'california' },
    { label: 'Colorado', value: 'colorado' },
    { label: 'Connecticut', value: 'connecticut' },
    { label: 'Delaware', value: 'delaware' },
    { label: 'District of Columbia', value: 'districtOfColumbia' },
    {
      label: 'Florida',
      value: 'florida',
    },
    { label: 'Georgia', value: 'georgia' },
    { label: 'Hawaii', value: 'hawaii' },
    { label: 'Idaho', value: 'idaho' },
    { label: 'Illinois', value: 'illinois' },

    { label: 'Indiana', value: 'indiana' },

    { label: 'Iowa', value: 'iowa' },
    { label: 'Kansas', value: 'kansas' },
    { label: 'Kentucky', value: 'kentucky' },

    { label: 'Louisiana', value: 'louisiana' },
    { label: 'Maine', value: 'maine' },
    { label: 'Maryland', value: 'maryland' },

    { label: 'Massachusetts', value: 'massachusetts' },
    { label: 'Michigan', value: 'michigan' },

    { label: 'Minnesota', value: 'minnesota' },
    { label: 'Mississippi', value: 'mississippi' },

    { label: 'Missouri', value: 'missouri' },
    { label: 'Montana', value: 'montana' },

    { label: 'Nebraska', value: 'nebraska' },
    { label: 'Nevada', value: 'nevada' },

    { label: 'New Hampshire', value: 'newHampshire' },
    { label: 'New Jersey', value: 'newJersey' },

    { label: 'New Mexico', value: 'newMexico' },

    { label: 'New York', value: 'newYork' },
    { label: 'North Carolina', value: 'northCarolina' },
    { label: 'North Dakota', value: 'northDakota' },

    { label: 'Ohio', value: 'ohio' },

    { label: 'Oklahoma', value: 'oklahoma' },
    { label: 'Oregon', value: 'oregon' },
    { label: 'Pennsylvania', value: 'pennsylvania' },
    { label: 'Rhode Island', value: 'rhodeIsland' },

    { label: 'South Carolina', value: 'southCarolina' },
    { label: 'South Dakota', value: 'southDakota' },
    { label: 'Tennessee', value: 'tennessee' },
    { label: 'Texas', value: 'texas' },

    { label: 'Utah', value: 'utah' },
    { label: 'Vermont', value: 'vermont' },
    { label: 'Virginia', value: 'virginia' },

    { label: 'Washington', value: 'washington' },

    { label: 'West Virginia', value: 'westVirginia' },

    { label: 'Wisconsin', value: 'wisconsin' },
    { label: 'Wyoming', value: 'wyoming' },
    // { label: 'Puerto Rico', value: 'puertoRico' },
    // { label: 'US Virgin Islands', value: 'usVirginIslands' },
    // { label: 'Bahamas Dental Council', value: 'bahamasDentalCouncil' },
  ],
  profession: {
    alabama: [
      { label: 'Occupational Therapist', value: 'occupationalTherapist' },
      {
        label: 'Occupational Therapy Assistant ',
        value: 'occupationalTherapyAssistant ',
      },
      { label: 'Dentist', value: 'dentist' },
      {
        label: 'Dental Hygienist',
        value: 'dentalHygienist',
      },
    ],

    alaska: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    arizona: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      { label: 'Athletic Trainer', value: 'athleticTrainer' },
      {
        label: 'Occupational Therapy Assistant',
        value: 'occupationalTherapyAssistant',
      },
      { label: 'Occupational Therapist', value: 'occupationalTherapist' },
    ],

    arkansas: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      {
        label: 'Registered Nurse Practitioner',
        value: 'registeredNursePractitioner',
      },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      {
        label: 'Licensed Psychiatric Technician Nurse',
        value: 'licensedPsychiatricTechnicianNurse',
      },
      {
        label: 'Certified Registered Nurse Anesthetist',
        value: 'certifiedRegisteredNurseAnesthetist',
      },
      {
        label: 'Certified Nurse Midwife',
        value: 'certifiedNurseMidwife',
      },
      {
        label: 'Clinical Nurse Specialist',
        value: 'clinicalNurseSpecialist',
      },
      {
        label: 'Certified Nurse Practitioner',
        value: 'certifiedNursePractitioner',
      },
    ],

    california: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    colorado: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    connecticut: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    delaware: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    districtOfColumbia: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      { label: 'Home Health Aids', value: 'homeHealthAids' },
    ],
    florida: [
      { label: 'Acupuncturist', value: 'acupuncturist' },
      {
        label: 'Advanced Practice Registered Nurse',
        value: 'advancedPracticeRegisteredNurse',
      },
      {
        label: 'Audiologist',
        value: 'audiologist',
      },
      {
        label: 'Audiology Assistant',
        value: 'audiologyAssistant',
      },
      {
        label: 'Certified Nursing Assistant',
        value: 'certifiedNursingAssistant',
      },
      {
        label: 'Certified Master Social Worker',
        value: 'certifiedMasterSocialWorker',
      },
      {
        label: 'Certified Optometrist',
        value: 'certifiedOptometrist',
      },
      {
        label: 'Certified Respiratory Therapist',
        value: 'certifiedRespiratoryTherapist',
      },
      {
        label: 'Chiropractic Physician',
        value: 'chiropracticPhysician',
      },
      {
        label: 'Clinical Laboratory Director',
        value: 'clinicalLaboratoryDirector',
      },
      {
        label: 'Clinical Laboratory Supervisor',
        value: 'clinicalLaboratorySupervisor',
      },
      {
        label: 'Clinical Laboratory Technician',
        value: 'clinicalLaboratoryTechnician',
      },
      {
        label: 'Clinical Laboratory Technologist',
        value: 'clinicalLaboratoryTechnologist',
      },
      {
        label: 'Dental Hygienist',
        value: 'dentalHygienist',
      },
      {
        label: 'Dental Labs',
        value: 'dentalLabs',
      },
      {
        label: 'Dentist',
        value: 'dentist',
      },
      {
        label: 'Diagnostic Radiological Physicist',
        value: 'diagnosticRadiologicalPhysicist',
      },
      {
        label: 'Dietician Nutritionist',
        value: 'dietician',
      },
      {
        label: 'Electrologist',
        value: 'electrologist',
      },
      {
        label: 'Emergency Medical Technician',
        value: 'emergencyMedicalTechnician',
      },
      {
        label: 'Health Access Dentist',
        value: 'healthAccessDentist',
      },
      {
        label: 'Hearing Aid Specialist',
        value: 'hearingAidSpecialist',
      },
      {
        label: 'Licensed Marriage and Family Therapist ',
        value: 'licensedMarriageAndFamilyTherapist ',
      },
      {
        label: 'Licensed Clinical Social Worker',
        value: 'licensedClinicalSocialWorker ',
      },
      {
        label: 'Licensed Mental Health Counselor',
        value: 'licensedMentalHealthCounselor',
      },
      {
        label: 'Licensed Practical Nurse',
        value: 'licensedPracticalNurse ',
      },
      {
        label: 'Massage Therapist',
        value: 'massageTherapist',
      },
      {
        label: 'Medical Doctor',
        value: 'medicalDoctor ',
      },
      {
        label: 'Midwife',
        value: 'midwife',
      },
      {
        label: 'Nursing Home Administrator',
        value: 'nursingHomeAdministrator',
      },
      {
        label: 'Occupational Therapist',
        value: 'occupationalTherapist',
      },
      {
        label: 'Occupational Therapy Assistant',
        value: 'occupationalTherapyAssistant ',
      },
      {
        label: 'Optometrist',
        value: 'optometrist',
      },
      {
        label: 'Paramedic',
        value: 'paramedic',
      },
      {
        label: 'Pharmacist',
        value: 'pharmacist ',
      },
      {
        label: 'Pharmacy Technician',
        value: 'pharmacyTechnician ',
      },
      {
        label: 'Physical Therapist',
        value: 'physicalTherapist',
      },
      {
        label: 'Physical Therapy Assistant',
        value: 'physicalTherapyAssistant',
      },
      {
        label: 'Physician Assistant',
        value: 'physicianAssistant',
      },
      {
        label: 'Podiatrist',
        value: 'podiatrist',
      },
      {
        label: 'Psychologist',
        value: 'psychologist',
      },
      {
        label: 'Registered Nurse',
        value: 'registeredNurse',
      },
      {
        label: 'Registered Respiratory Therapist',
        value: 'registeredRespiratoryTherapist',
      },
      {
        label: 'Respiratory Care Practitioner Critical Care',
        value: 'respiratoryCarePractitionerCriticalCare ',
      },
      {
        label: 'Respiratory Care Practitioner Non-Critical Care',
        value: 'respiratoryCarePractitionerNonCriticalCare ',
      },
      {
        label: 'Speech Language Pathologist',
        value: 'speechLanguagePathologist',
      },
      {
        label: 'Speech Language Pathology Assistant',
        value: 'speechLanguagePathologyAssistant',
      },
    ],
    georgia: [
      {
        label: 'Registered Nurse',
        value: 'registeredNurse',
      },
      {
        label: 'Licensed Practical Nurse',
        value: 'licensedPracticalNurse',
      },
      {
        label: 'Massage Therapist',
        value: 'massageTherapist',
      },
      {
        label: 'Nursing Home Administrator',
        value: 'nursingHomeAdministrator',
      },
      {
        label: 'Occupational Therapist',
        value: 'occupationalTherapist',
      },
      {
        label: 'Occupational Therapist Assistant ',
        value: 'occupationalTherapistAssistant ',
      },
      {
        label: 'Physical Therapist',
        value: 'physicalTherapist',
      },
      {
        label: 'Physical Therapist Assistant',
        value: 'physicalTherapistAssistant',
      },
    ],

    hawaii: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    idaho: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      { label: 'Electrical Journeyman', value: 'electricalJourneyman' },
      { label: 'Master Electrician', value: 'masterElectrician' },
      { label: 'Plumbing Journeyman', value: 'plumbingJourneyman' },
      { label: 'Plumbing Contractor', value: 'plumbingContractor' },
    ],

    illinois: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    indiana: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    iowa: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    kansas: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    kentucky: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    louisiana: [
      {
        label: 'Dental Hygienist',
        value: 'dentalHygienist',
      },
      {
        label: 'Dentist',
        value: 'dentist',
      },
    ],

    maine: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    maryland: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    massachusetts: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    michigan: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      { label: 'Electrical Apprentice', value: 'electricalApprentice' },
      { label: 'Electrical Journeyman', value: 'electricalJourneyman' },
      { label: 'Master Electrician', value: 'masterElectrician' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    minnesota: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    mississippi: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      { label: 'Occupational Therapist', value: 'occupationalTherapist' },
      {
        label: 'Occupational Therapy Assistant',
        value: 'occupationalTherapyAssistant',
      },
      {
        label: 'Respiratory Care Practitioner',
        value: 'respiratoryCarePractitioner',
      },

      // {label: 'Dentist', value: 'dentist'}
    ],

    missouri: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    montana: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    nebraska: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    nevada: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    newHampshire: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    newJersey: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    newMexico: [
      {
        label: 'Certified Hemodialysis Technician',
        value: 'certifiedHemodialysisTechnician',
      },
      {
        label: 'Certified Hemodialysis Technician II',
        value: 'certifiedHemodialysisTechnicianII',
      },
      {
        label: 'Certified Medication Aide',
        value: 'certifiedMedicationAide',
      },
      {
        label: 'Certified Medication Aide II',
        value: 'certifiedMedicationAideII',
      },
      {
        label: 'Certified Nurse Practitioner',
        value: 'certifiedNursePractitioner',
      },
      {
        label: 'Certified Nurse Specialist',
        value: 'certifiedNurseSpecialist',
      },
      {
        label: 'Certified Registered Nurse Anesthetist',
        value: 'certifiedRegisteredNurseAnesthetist',
      },
      {
        label: 'Lactation Care Provider',
        value: 'lactationCareProvider',
      },
      {
        label: 'Licensed Practical Nurse',
        value: 'licensedPracticalNurse',
      },
      {
        label: 'Registered Nurse',
        value: 'registeredNurse',
      },
    ],

    newYork: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    northCarolina: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    northDakota: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    ohio: [
      {
        label: 'Advanced Cosmetologist',
        value: 'advancedCosmetologist',
      },
      {
        label: 'Advanced Esthetician',
        value: 'advancedEsthetician',
      },
      {
        label: 'Advanced Hair Designer',
        value: 'advancedHairDesigner',
      },
      {
        label: 'Advanced Manicurist',
        value: 'advancedManicurist',
      },
      {
        label: 'Advanced Natural Hair Stylist',
        value: 'advancedNaturalHairStylist',
      },
      {
        label: 'Audiologist',
        value: 'audiologist',
      },
      {
        label: 'Cosmetologist Instructor',
        value: 'cosmetologistInstructor',
      },
      {
        label: 'Cosmetologist',
        value: 'cosmetologist',
      },

      {
        label: 'Esthetician',
        value: 'esthetician',
      },
      {
        label: 'Esthetician Instructor',
        value: 'estheticianInstructor',
      },
      {
        label: 'Hair Designer',
        value: 'hairDesigner',
      },
      {
        label: 'Hair Designer Instructor',
        value: 'hairDesignerInstructor',
      },
      {
        label: 'Hearing Aid Specialist/Fitter',
        value: 'hearingAidSpecialistFitter',
      },
      {
        label: 'Licensed Professional Counselor',
        value: 'licensedProfessionalCounselor',
      },
      {
        label: 'Licensed Professional Clinical Counselor',
        value: 'licensedProfessionalClinicalCounselor',
      },
      {
        label: 'Independent Marriage and Family Therapist',
        value: 'independentMarriageAndFamilyTherapist',
      },
      {
        label: 'Licensed Social Worker',
        value: 'licensedSocialWorker',
      },
      {
        label: 'Manicurist Instructor',
        value: 'manicuristInstructor',
      },
      {
        label: 'Manicurist',
        value: 'manicurist',
      },
      {
        label: 'Marriage and Family Therapist',
        value: 'marriageAndFamilyTherapist',
      },
      {
        label: 'Natural Hair Stylist',
        value: 'naturalHairStylist',
      },
      {
        label: 'Natural Hair Stylist Instructor',
        value: 'naturalHairStylistInstructor',
      },
      {
        label: 'Registered Social Work Assistant',
        value: 'registeredSocialWorkAssistant',
      },
      {
        label: 'Speech Language Pathologist',
        value: 'speechLanguagePathologist',
      },
    ],

    oklahoma: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },

      {
        label: 'Real Estate Sales Associate',
        value: 'realEstateSalesAssociate',
      },
      { label: 'Real Estate Broker', value: 'realEstateBroker' },
      {
        label: 'Real Estate Broker Associate',
        value: 'realEstateBrokerAssociate',
      },
      // {label: 'Dentist', value: 'dentist'}
    ],

    oregon: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    pennsylvania: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    rhodeIsland: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    southCarolina: [
      {
        label: 'Advanced Practice Registered Nurse',
        value: 'advancedPracticeRegisteredNurse',
      },
      {
        label: 'Dentist',
        value: 'dentist',
      },
      {
        label: 'Dental Hygienist',
        value: 'dentalHygienist',
      },
      {
        label: 'Dental Specialist',
        value: 'dentalSpecialist',
      },
      {
        label: 'Dental Technician',
        value: 'dentalTechnician',
      },
      {
        label: 'Licensed Practical Nurse',
        value: 'licensedPracticalNurse',
      },
      {
        label: 'Massage Therapist',
        value: 'massageTherapist',
      },
      {
        label: 'Physical Therapist',
        value: 'physicalTherapist',
      },
      {
        label: 'Physical Therapy Assistant',
        value: 'physicalTherapyAssistant',
      },
      {
        label: 'Real Estate Salesman',
        value: 'realEstateSalesman',
      },
      {
        label: 'Real Estate Broker',
        value: 'realEstateBroker',
      },
      {
        label: 'Real Estate Broker In Charge',
        value: 'realEstateBrokerInCharge',
      },
      {
        label: 'Registered Nurse',
        value: 'registeredNurse',
      },
    ],

    southDakota: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    tennessee: [
      {
        label: 'Dentist',
        value: 'dentist',
      },
      {
        label: 'Dental Assistant',
        value: 'dentalAssistant',
      },
      {
        label: 'Dental Hygienist',
        value: 'dentalHygienist',
      },
      {
        label: 'Clinical Laboratory Personnel',
        value: 'clinicalLaboratoryPersonnel ',
      },
    ],

    texas: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    utah: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    vermont: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    virginia: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    washington: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    westVirginia: [
      {
        label: 'Advanced Practice Registered Nurse',
        value: 'advancedPracticeRegisteredNurse',
      },
      {
        label: 'Registered Nurse',
        value: 'registeredNurse',
      },
    ],

    wisconsin: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],
    wyoming: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      // {label: 'Dentist', value: 'dentist'}
    ],

    // puertoRico: [
    //   { label: 'Registered Nurse', value: 'registeredNurse' },
    //   { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
    // ],

    // usVirginIslands: [
    //   { label: 'Registered Nurse', value: 'registeredNurse' },
    //   { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
    // ],
  },
};

export const getOptions = (type, values) => {
  let result = null;
  switch (type) {
    case 'profession':
      result = options[type][values.value] || [];
      break;
    default:
      result = options[type] || [];
  }
  return [{ label: '', value: '' }].concat(result);
};

// NURSE OPTIONS

export const nurseOptions = {
  state: [
    { label: 'Arkansas', value: 'arkansas' },
    { label: 'District of Columbia', value: 'districtOfColumbia' },
    {
      label: 'Florida',
      value: 'florida',
    },
    { label: 'Georgia', value: 'georgia' },

    { label: 'South Carolina', value: 'southCarolina' },

    { label: 'West Virginia', value: 'westVirginia' },
  ],
  profession: {
    arkansas: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      {
        label: 'Registered Nurse Practitioner',
        value: 'registeredNursePractitioner',
      },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      {
        label: 'Licensed Psychiatric Technician Nurse',
        value: 'licensedPsychiatricTechnicianNurse',
      },
      {
        label: 'Certified Registered Nurse Anesthetist',
        value: 'certifiedRegisteredNurseAnesthetist',
      },
      {
        label: 'Certified Nurse Midwife',
        value: 'certifiedNurseMidwife',
      },
      {
        label: 'Clinical Nurse Specialist',
        value: 'clinicalNurseSpecialist',
      },
      {
        label: 'Certified Nurse Practitioner',
        value: 'certifiedNursePractitioner',
      },
    ],
    districtOfColumbia: [
      { label: 'Registered Nurse', value: 'registeredNurse' },
      { label: 'Licensed Practical Nurse', value: 'licensedPracticalNurse' },
      { label: 'Home Health Aids', value: 'homeHealthAids' },
    ],
    florida: [
      {
        label: 'Advanced Practice Registered Nurse',
        value: 'advancedPracticeRegisteredNurse',
      },

      {
        label: 'Certified Nursing Assistant',
        value: 'certifiedNursingAssistant',
      },
      {
        label: 'Licensed Practical Nurse',
        value: 'licensedPracticalNurse ',
      },

      {
        label: 'Midwife',
        value: 'midwife ',
      },
      {
        label: 'Nursing Home Administrator',
        value: 'nursingHomeAdministrator',
      },

      {
        label: 'Registered Nurse',
        value: 'registeredNurse',
      },
    ],
    georgia: [
      {
        label: 'Registered Nurse',
        value: 'registeredNurse',
      },
      {
        label: 'Licensed Practical Nurse',
        value: 'licensedPracticalNurse',
      },
    ],

    southCarolina: [
      {
        label: 'Advanced Practice Registered Nurse',
        value: 'advancedPracticeRegisteredNurse',
      },

      {
        label: 'Licensed Practical Nurse',
        value: 'licensedPracticalNurse',
      },

      {
        label: 'Registered Nurse',
        value: 'registeredNurse',
      },
    ],

    westVirginia: [
      {
        label: 'Advanced Practice Registered Nurse',
        value: 'advancedPracticeRegisteredNurse',
      },
      {
        label: 'Registered Nurse',
        value: 'registeredNurse',
      },
    ],
  },
};

export const getNurseOptions = (type, values) => {
  let result = null;
  switch (type) {
    case 'profession':
      result = nurseOptions[type][values.value] || [];
      break;
    default:
      result = nurseOptions[type] || [];
  }
  return [{ label: '', value: '' }].concat(result);
};



// WEBPACK FOOTER //
// ./src/fixture/data.js